module.exports = __webpack_public_path__ + "static/media/10-5.1d72dcf4.mp3";